const { contractsValidationsErrorMessages } = require('constants/contractsValidations');
const {
    EURO_SYMBOL,
    INTERVENER_LABEL_HOLDER,
    INTERVENER_LABEL_AUTHORIZED,
    INTERVENER_LABEL_EMPOWERED
} = require('constants/index');

module.exports = {
    title: 'contractsView-contractsView_noNewMoneyDepositStep2Title',
    order: 2,
    footer_text: '',
    disableNext: 'depositEighteenMonthsRetention_nextButtonDisabled',
    position: 'middle',
    components:
        [
            {
                id_component: 'dropdown-accounts',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Account',
                options: [],
                type: 'single',
                target: 'cta_seleccionada',
                targetIntervener: 'intervinientes_list',
                intervenersSpecial: true,
                order: 1,
                isIntervenerAvailable: true,
                renderInterveners: 'depositEighteenMonthsRetention_shouldBuild',
                isMaxAmountLabelAvailable: false,
                intervenersHeader: 'contractsView-contractsView_noNewMoneyDepositIntervenersHeader',
                maxAmountValue: 0,
                required: true,
                errorMessage: contractsValidationsErrorMessages.ERROR_MESSAGE_REQUIRED_DROPDOWN_ACCOUNTS_DEPOSIT_EIGHTEEN_RETENTION,
                accountChangeExtraFn: 'refreshNoNewMoneyDepositHireInformation',
                intervenersHierarchicalTypeSelection: true,
                intervenerOptions: [
                    INTERVENER_LABEL_HOLDER,
                    INTERVENER_LABEL_AUTHORIZED,
                    INTERVENER_LABEL_EMPOWERED
                ],
                showIntervenerControls: true,
                restoreDefaultIntervenersEnabled: true
            },
            {
                id_component: 'slider',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Amount',
                min_value: 0,// is populated by service
                max_value: 0,// is populated by service
                default_value: 0,// is populated by service
                value: null,// is populated by service
                type: 'single',
                format_type: EURO_SYMBOL,
                inputType: 'float',
                onChangeFn: 'depositEighteenMonthsRetention_onChangeAmount',
                is_money: true,
                title: 'contractsView-amountTitle',
                target: 'monto_traspasar',
                source: 'depositEighteenMonthsRetention_loadSliderAmounts',
                buildCondition: 'depositEighteenMonthsRetention_shouldBuild'
            },
            {
                id_component: 'interest-band'
            },
            {
                id_component: 'checkbox',
                id: 'renewDeposit',
                target: 'renewDeposit',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Renew',
                type: 'single',
                onChangeFn: 'depositEighteenMonthsRetention_onChangeCheckbox',
                buildCondition: 'depositEighteenMonthsRetention_shouldBuild'
            },
            {
                id_component: 'validation-modal',
                id: 'validationModal',
                title: 'contractsView-contractsView_noNewMoneyDepositStep2ValidationModalTitle',
                titleType: '',
                content: 'depositEighteenMonthsRetention_FinalModalChildren',
                allowContinue: true,
                open: 'depositEighteenMonthsRetention_showFinalModal',
                showCloseButton: false,
                leaveButtonText: 'contractsView-depositEighteenMonthsBackButtonModal'
            },
            {
                id_component: 'disclaimer-personal-info',
                messageKey: 'depositEighteenMonthsRetentionMsg',
                linkTextKey: 'depositEighteenMonthsRetentionLinkText',
                linkUrlKey: 'depositEighteenMonthsRetentionLinkUrl'
            }
        ]
};
